
import { getToken } from "firebase/messaging";
import { messaging } from "./firebaseConfig";

const VAPID_KEY = "BDM0Rv6rHmJVGvOXd_7XZ010oB7hN8NoNDjjedvMZEPwI23aYRg2-UqUwndokMaykBBKQhDNKk1InvAyHTJ4KqY";

export const createFCMToken = async () => {
  try {
    return await getToken(messaging, { vapidKey: VAPID_KEY });
  } catch (error) {
    console.error("Error getting create FCM token:", error);
  }
}